export const Divider = {
  border: '2px solid',
  width: '20%',
  marginX: 'auto',
  marginTop: 0,
  marginBottom: 1,
};
